import { createSelector } from '@reduxjs/toolkit'

import { getSecurity } from '../../root.selectors'

export const getFirewall = createSelector(getSecurity, (security) => security.firewall)
export const getFirewallFilterRule = createSelector(getFirewall, (firewallSlice) => firewallSlice.rule)
